export enum DealStageCategory {
  LEAD = "LEAD",
  PIPELINE = "PIPELINE",
  WON = "WON",
  LOST = "LOST",
}

export const DEAL_STAGE_CATEGORY_ORDER = [
  DealStageCategory.LEAD,
  DealStageCategory.PIPELINE,
  DealStageCategory.WON,
  DealStageCategory.LOST,
];

export const DEAL_STAGE_CATEGORY_LABELS: Record<DealStageCategory, string> = {
  [DealStageCategory.LEAD]: "Lead stages",
  [DealStageCategory.PIPELINE]: "Pipeline stages",
  [DealStageCategory.WON]: "Won",
  [DealStageCategory.LOST]: "Lost",
};

export const DEAL_STAGE_CATEGORY_DESCRIPTIONS: Record<DealStageCategory, string> = {
  [DealStageCategory.LEAD]: "Hidden from the pipeline. People here stay leads.",
  [DealStageCategory.PIPELINE]: "Shown on the pipeline. A lead whose deal gets here becomes a contact.",
  [DealStageCategory.WON]: "Counts as won. A lead whose deal lands here becomes a contact.",
  [DealStageCategory.LOST]: "Counts as lost. Nobody changes type.",
};

export function stageCategoryConverts(category?: DealStageCategory | string | null): boolean {
  return category === DealStageCategory.PIPELINE || category === DealStageCategory.WON;
}

export function stageCategoryOf(stage?: { category?: DealStageCategory | string | null } | null): DealStageCategory {
  const category = stage?.category;
  if (category && Object.values(DealStageCategory).includes(category as DealStageCategory)) {
    return category as DealStageCategory;
  }
  return DealStageCategory.PIPELINE;
}
